export const data = {
    path: '/cookies',
    seo: {
        title: 'Cookie policy',
        description: 'Read all about the cookies that The Pack - Digital Agency uses.',
    },
};
